import React from "react";
import { ObjectPanelTabs } from "./co-panel/ObjectPanelComponent";

export interface ScrollViewNavigationProps {
  items: ObjectPanelTabs[];
  activeLink: string;
  onClickScrollView?: (item: ObjectPanelTabs, index: number) => void;
  isClickEnabled: boolean;
}

export const ScrollViewNavigation: React.FunctionComponent<ScrollViewNavigationProps> = (props) => {
  const { items, activeLink, onClickScrollView, isClickEnabled } = props;

  function onClick(selected: ObjectPanelTabs, index: number) {
    if (isClickEnabled) {
      onClickScrollView(selected, index);
    }
  }

  return (
    <div className="k-scrollview-nav-wrap">
      <ul className="k-scrollview-nav">
        {items ? (
          items.map((n, index) => {
            const isPreviousItemValid = index === 0 || items[index - 1].isValid;
            return (
              <li
                key={n.key}
                className={`k-link ${activeLink == n.key ? "k-primary" : ""}`}
                style={isPreviousItemValid ? {} : { cursor: "not-allowed" }}
                onClick={() => {
                  if (isPreviousItemValid) onClick(n, index);
                }}
              />
            );
          })
        ) : (
          <li className={`k-link k-primary`} />
        )}
      </ul>
    </div>
  );
};
